import { booleanAttribute, ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  DsFormFieldModule,
  DsIconModule,
  DsSelectModule,
  DsTooltipDirectiveModule,
  InlineFormFieldConfig,
  SelectListOption,
} from '@bmw-ds/components';

@Component({
  selector: 'cdf-select-field',
  host: { class: 'col' },
  imports: [DsFormFieldModule, FormsModule, DsSelectModule, DsTooltipDirectiveModule, DsIconModule],
  template: `
    <ds-form-field [inlineConfig]="inlineConfig()" class="d-flex gap-2x">
      @if (label()) {
        <label ds-label>{{ label() }}</label>
      }
      <ds-select
        [(ngModel)]="model"
        [id]="id()"
        [attr.aria-invalid]="displayError()"
        [showClearAll]="isClearable()"
        [labellingConfig]="{ placeholder: placeholder() }"
        [attr.title]="placeholder()"
        [options]="options()"
        [disabled]="disabled()"
        [ds-tooltip]="disabledTooltip()"
        [dsTooltipConfig]="{ disabled: !this.disabled() || !disabledTooltip() }"
      />
    </ds-form-field>

    @if (displayError() && errorMessage()) {
      <div class="error-message">
        <ds-icon icon="information" size="sm" />
        <span class="text-label">{{ errorMessage() }}</span>
      </div>
    }
  `,
  styleUrl: './select-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectFieldComponent {
  readonly id = input.required<string>();
  readonly placeholder = input<string>();
  readonly options = input.required<SelectListOption[]>();
  readonly model = model<string>();

  readonly isClearable = input(false, { transform: booleanAttribute });

  readonly displayError = input(false);
  readonly errorMessage = input<string>();

  // If set to true, doubles the width of the input field
  readonly hasDoubleWidth = input(false, { transform: booleanAttribute });

  readonly disabledTooltip = input<string>('');
  readonly disabled = input(false, { transform: booleanAttribute });

  readonly label = input<string>();

  readonly inlineConfig = input<Partial<InlineFormFieldConfig> | null>(null);
}
